import $          from 'jquery';
import cx         from 'classnames';
import React      from 'react';
import ReactDOM   from 'react-dom';
import Reflux     from 'reflux';
import Choices    from './choices';
import InputField from './input-field';
import Textarea   from './textarea';
import DiscussionIntroductionField from './discussion-introduction-field';
import Utils      from 'medscape/utils';



export default class Question extends React.Component {
  constructor(props) {
    super(props);
    let choices = props.question.choices.sort( (choiceA, choiceB)=>{
      return choiceA.displayOrder - choiceB.displayOrder;
    });
    props.question.choices = choices;
  }
  getChoicesType() {
    let choices;
    let question = this.props.question;
    if(question.answered) {
      if(question.showAnsTable){
        if(question.poll) {
          return Choices.PollResults;
        } else {
          return Choices.QnaResults;
        }
      } else {
        if(question.poll) {
            return Choices.QnaResults;
        }
        return Choices.QnaResults;
      }
    }
    switch(question.displayType) {
      case 1:
        choices = Choices.Radio;
        break;
      case 2:
        choices = Choices.Checkbox;
        break;
      case 3:
        choices = Choices.Select;
        break;
      case 4:
        choices = InputField;
        break;
      case 5:
        choices = Textarea;
        break;
      default:
        choices = null;
    }
    return choices;
  }
  isAnswered() {
    const question = this.props.question;
    let isAnswered = question.answered;
    if(isAnswered) return true;
    if(question.displayType==4 || question.displayType==5) {
      return question.responseText!=null && question.responseText.length>0;
    } else {
      let choices = question.choices;
      let choice = choices.find((choice)=>{
          return choice.selected;
      });
      return (choice!=null);
    }
  }
  render() {
    let question = this.props.question;
    let fieldsetId = "questions-item-"+question.questionId;
    const isRequired = question.required;
    const isAnswered = this.isAnswered();
    let questionClass = cx({
      "question-item": true,
      "required": isRequired,
      "answered": isAnswered
    })
    let questionDescription = (this.props.flagRequired && isRequired && !question.answered) ? `<span class="asterisk">*</span> ${question.questionText}` : question.questionText;
    let description = Utils.getDangerousHtml(questionDescription);
    let choiceProps = {
      question: question
    }
    let ChoicesType = this.getChoicesType();
    if(ChoicesType==null) {
        return false;
        /*
        return (
            <fieldset>
                <div className="description" dangerouslySetInnerHTML={description}>
                </div>
                <div>(DisplayType: {this.props.question.displayType}) Not Implemented</div>
            </fieldset>
        );
        */
    }

    let discussionIntroFieldProps = {
      content: isAnswered ? question.discussion : question.introduction,
      type: isAnswered ? DiscussionIntroductionField.types.DISCUSSION : DiscussionIntroductionField.types.INTRODUCTION
    }

    const QuestionCounter = ()=>{
        if(this.props.questionNumberText.length==0){
            return false;
        }
        let questionHtml = Utils.getDangerousHtml(this.props.questionNumberText);
        return (
            <h5 className="question-number" dangerouslySetInnerHTML={questionHtml}></h5>
        )
    }
    return(
      <fieldset id={fieldsetId} className={questionClass}>
        {QuestionCounter()}
        <div className="description" dangerouslySetInnerHTML={description}>
        </div>
        <ChoicesType {...choiceProps}  />
        <DiscussionIntroductionField {...discussionIntroFieldProps} />
      </fieldset>
    )
  }
}
Question.propTypes={
  question: React.PropTypes.object.isRequired,
  index: React.PropTypes.number,
  flagRequired: React.PropTypes.bool,
  questionNumberText: React.PropTypes.string
}
Question.defaultProps={
  index: 0,
  flagRequired: false,
  questionNumberText: ''
}



// WEBPACK FOOTER //
// ./medscape_modules/qna/form-components/question.jsx